// src/index.tsx
import './index.css';

// Initialize Keycloak BEFORE React
const initAuth = async () => {
  try {
    const { default: Keycloak } = await import('keycloak-js');
    const kc = new Keycloak({
      url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080',
      realm: process.env.REACT_APP_KEYCLOAK_REALM || 'Xtrem',
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'Xtrem-portal',
    });

    const authenticated = await kc.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      pkceMethod: 'S256'
    });

    if (!authenticated) {
      // If we're not authenticated after check-sso, we must login
      await kc.login();
      return; // Stop here, redirect will happen
    }

    if (authenticated) {
      (window as any).keycloak = kc;

      // Now load and render React app
      const { default: React } = await import('react');
      const { createRoot } = await import('react-dom/client');
      const { default: App } = await import('./App');

      // Ensure root element exists
      if (!document.getElementById('root')) {
        const rootEl = document.createElement('div');
        rootEl.id = 'root';
        document.body.appendChild(rootEl);
      }

      const root = createRoot(document.getElementById('root')!);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );

      // Optional: performance monitoring
      const { default: reportWebVitals } = await import('./reportWebVitals');
      reportWebVitals();
    }
  } catch (error) {
    console.error('Authentication failed:', error);
    document.body.innerHTML = '<h1 style="text-align:center;margin-top:50px;color:red;">Authentication failed. Please reload.</h1>';
  }
};

initAuth();